export default function promiseMiddleware(api) {
  return () => next => (action) => {
    const { nextAction, promise, type, ...rest } = action

    if (!promise) {
      return next(action)
    }

    const [REQUEST, SUCCESS, FAILURE] = type

    next({ ...rest, type: REQUEST })

    function success(res) {
      next({ ...rest, payload: res, type: SUCCESS })
      if (nextAction) {
        nextAction(res)
      }
    }

    function error(err) {
      next({ ...rest, payload: err, type: FAILURE })
    }

    return promise(api)
      .then(success, error)
      .catch((err) => {
        console.error('ERROR ON THE MIDDLEWARE: ', REQUEST, err) // eslint-disable-line no-console
        next({ ...rest, payload: err, type: FAILURE })
      })
  }
}
